import * as React from 'react';

export const Target = props => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.49902 13.2472C2.49902 8.15787 6.62489 4.0332 11.714 4.0332C16.8021 4.0332 20.928 8.15792 20.928 13.2472C20.928 18.3365 16.8021 22.4612 11.714 22.4612C6.62489 22.4612 2.49902 18.3365 2.49902 13.2472ZM11.714 5.5332C7.45309 5.5332 3.99902 8.98652 3.99902 13.2472C3.99902 17.5079 7.45309 20.9612 11.714 20.9612C15.9738 20.9612 19.428 17.5079 19.428 13.2472C19.428 8.98646 15.9738 5.5332 11.714 5.5332Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.37988 13.2471C6.37988 10.2998 8.76872 7.91211 11.7148 7.91211C14.6601 7.91211 17.0489 10.2999 17.0489 13.2471C17.0489 16.1924 14.66 18.5811 11.7148 18.5811C8.76873 18.5811 6.37988 16.1924 6.37988 13.2471ZM11.7148 9.41211C9.59696 9.41211 7.87988 11.1284 7.87988 13.2471C7.87988 15.3638 9.59696 17.0811 11.7148 17.0811C13.8316 17.0811 15.5489 15.3639 15.5489 13.2471C15.5489 11.1284 13.8316 9.41211 11.7148 9.41211Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1375 3.10352C19.5517 3.10352 19.8875 3.4393 19.8875 3.85352V5.21552H21.2515C21.6657 5.21552 22.0015 5.5513 22.0015 5.96552C22.0015 6.37973 21.6657 6.71552 21.2515 6.71552H19.4482L12.5079 13.6568C12.215 13.9497 11.7402 13.9498 11.4472 13.6569C11.1543 13.364 11.1543 12.8891 11.4472 12.5962L18.3875 5.65489V3.85352C18.3875 3.4393 18.7233 3.10352 19.1375 3.10352Z"
      fill="#64748B"
    />
  </svg>
);
